import { render, staticRenderFns } from "./WebCopyRight.vue?vue&type=template&id=4d7ceb83&"
import script from "./WebCopyRight.vue?vue&type=script&lang=js&"
export * from "./WebCopyRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports